export default "/images/vendor/flag-icon-css/flags/4x3/va.svg?6d6a5ae672030a7e351ffa3265e44c32";